var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-card',{staticClass:"mt-5 text-center",attrs:{"border-variant":"danger"}},[_c('b-card-title',[_vm._v("The location you are trying to reach does not exist")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }